import useScreenSize from '../../../core/hooks/useScreenSize';
import { useExperienceSleepContext } from '../../../core/context/ExperienceSleepContext';
import Header from '../../../components/Header/Header';
import ExperienceHeader from '../../../components/ExperienceHeader/ExperienceHeader';
import ExperienceIframe from '../../../components/ExperienceIframe/ExperienceIframe';
import StoryList from '../../../components/StoryList/StoryList';
import StoryInfo from '../../../components/ScrollInfo/ScrollInfo';
import ExperienceInfo from '../../../components/ExperienceInfo/ExperienceInfo';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledDividedPageContent,
} from '../../../styles/config/pageStyle';

function ExperienceSleep() {
  const {
    recommendedExperiences,
    recommendedHeading,
    infoContent,
    suggestedQuestions,
    iframeData,
  } = useExperienceSleepContext();
  const [size] = useScreenSize();

  return (
    <>
      <Header title="sleep" isNavHidden />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <StyledDividedPageContent>
              {size > 991 ? (
                <ExperienceInfo
                  infoContent={infoContent}
                  questions={suggestedQuestions}
                  experienceName="Sleep"
                />
              ) : (
                <ExperienceHeader
                  menuComponent={
                    <StoryList
                      data={recommendedExperiences}
                      heading={recommendedHeading}
                      sidebar
                      mobileVertical
                    />
                  }
                  infoComponent={
                    <ExperienceInfo
                      infoContent={infoContent}
                      questions={suggestedQuestions}
                      experienceName="Sleep"
                    />
                  }
                />
              )}
              <ExperienceIframe data={iframeData} />
            </StyledDividedPageContent>
            {size > 991 && (
              <>
                <StoryInfo data={{ title: 'Scroll down to see more' }} />
                <StoryList
                  data={recommendedExperiences}
                  heading={recommendedHeading}
                  border={false}
                />
              </>
            )}
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default ExperienceSleep;
